import { NgModule } from '@angular/core';
import { AccordionComponent } from './accordion.component';
import { AccordionHeaderComponent } from './accordion-header/accordion-header.component';
import { AccordionContentComponent } from './accordion-content/accordion-content.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { IconButtonModule } from '../../icon-button/icon-button.module';

@NgModule({
  declarations: [
    AccordionComponent,
    AccordionHeaderComponent,
    AccordionContentComponent,
  ],
  exports: [
    AccordionComponent,
    AccordionHeaderComponent,
    AccordionContentComponent,
  ],
  imports: [CommonModule, MatIconModule, IconButtonModule],
})
export class AccordionModule {}
